import { LOGO_URL } from "../lib/api";
import { Instagram, Linkedin, Facebook, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <img src={LOGO_URL} alt="Content Lab" className="h-10 w-auto object-contain" />
            <p className="mt-5 max-w-sm text-slate-600">
              The marketing lab for doctors, clinics &amp; wellness brands. We make great
              healthcare impossible to ignore.
            </p>
            <div className="mt-6 flex gap-3">
              {[
                { Icon: Instagram, label: "Instagram", href: "https://www.instagram.com/contentlabpharma" },
                { Icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/company/143022918" },
                { Icon: Facebook, label: "Facebook", href: "https://www.facebook.com/profile.php?id=61592561343945" },
                { Icon: Mail, label: "Email", href: "mailto:contentlabpharma@gmail.com" },
              ].map(({ Icon, label, href }, i) => {
                const external = href.startsWith("http");
                return (
                  <a
                    key={i}
                    href={href}
                    aria-label={label}
                    target={external ? "_blank" : undefined}
                    rel={external ? "noopener noreferrer" : undefined}
                    data-testid={`footer-social-${i}`}
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 text-obsidian transition-colors duration-300 hover:border-blue-brand hover:text-blue-brand"
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                );
              })}
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">Services</p>
            <ul className="mt-4 space-y-2 text-slate-600">
              <li>Content Creation</li>
              <li>Social Media</li>
              <li>Website Design</li>
              <li>Google My Business</li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">Contact</p>
            <ul className="mt-4 space-y-2 break-words text-slate-600">
              <li>contentlabpharma@gmail.com</li>
              <li>+91-9987540065</li>
              <li>Monday to Friday, 10am to 10pm</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-slate-200 pt-8 md:flex-row md:items-center">
          <p className="font-mono text-xs text-slate-400">© {new Date().getFullYear()} Content Lab. All rights reserved.</p>
          <p className="font-mono text-xs text-slate-400">Healthcare marketing, prescribed.</p>
        </div>
      </div>
    </footer>
  );
}
